import styled from 'styled-components';

export const DataTextArea = styled.div`
  position: absolute;
  right: 0;
  background: ${({ theme }) => theme.backgroundModal};
`;
